(function () {
  var MOBILE_MQ = '(max-width: 989px)';

  var SCOPES = [
    {
      root: '.ctr-header__mobile-nav',
      link: '.ctr-header__mobile-nav-link',
      activeClass: 'ctr-header__mobile-nav-link--active',
      mobileOnly: true,
      scrollIntoView: true,
    },
    {
      root: '.ctr-header .header__inline-menu',
      link: 'a.header__menu-item',
      activeClass: 'header__menu-item--active',
      mobileOnly: false,
      scrollIntoView: false,
    },
  ];

  function getHashId(href) {
    if (!href || href === '#' || href === '/') return '';

    var hashIndex = href.indexOf('#');
    if (hashIndex === -1) return '';

    var id = href.slice(hashIndex + 1).split('?')[0].split('&')[0];
    try {
      id = decodeURIComponent(id);
    } catch (e) {}

    return id.trim();
  }

  function getOffset() {
    var styles = getComputedStyle(document.documentElement);
    var announcement = parseFloat(styles.getPropertyValue('--ctr-announcement-height')) || 0;
    var timer = parseFloat(styles.getPropertyValue('--ctr-timer-height')) || 0;
    var header = parseFloat(styles.getPropertyValue('--header-height')) || 0;

    if (!header) {
      var headerEl = document.querySelector('.section-header');
      if (headerEl) header = headerEl.getBoundingClientRect().height;
    }

    return Math.ceil(announcement + timer + header) + 8;
  }

  function resolveTarget(id) {
    if (!id) return null;

    var byId = document.getElementById(id);
    if (byId) return byId;

    try {
      var escaped =
        typeof CSS !== 'undefined' && CSS.escape ? CSS.escape(id) : id.replace(/"/g, '\\"');
      return (
        document.querySelector('[id="' + escaped + '"]') ||
        document.querySelector('[name="' + escaped + '"]')
      );
    } catch (e) {
      return null;
    }
  }

  function scrollLinkIntoView(root, link) {
    if (!root || !link) return;
    var list = root.querySelector('.ctr-header__mobile-nav-list');
    if (!list) return;

    var listRect = list.getBoundingClientRect();
    var linkRect = link.getBoundingClientRect();
    var left = linkRect.left - listRect.left + list.scrollLeft;
    var target = left - listRect.width / 2 + linkRect.width / 2;

    list.scrollTo({
      left: Math.max(0, target),
      behavior: 'smooth',
    });
  }

  function setActiveLink(scope, root, activeLink) {
    if (root._ctrNavSpyActive === activeLink) return;
    root._ctrNavSpyActive = activeLink;

    var links = root.querySelectorAll(scope.link);
    links.forEach(function (link) {
      var isActive = link === activeLink;
      link.classList.toggle(scope.activeClass, isActive);

      var label = link.querySelector('span');
      if (label) {
        label.classList.toggle('header__active-menu-item', isActive);
      }

      if (isActive) {
        link.setAttribute('aria-current', 'true');
      } else if (link.getAttribute('aria-current') === 'true') {
        link.removeAttribute('aria-current');
      }
    });

    if (activeLink && scope.scrollIntoView) {
      scrollLinkIntoView(root, activeLink);
    }
  }

  function buildEntries(scope, root) {
    var links = Array.prototype.slice.call(root.querySelectorAll(scope.link));
    var entries = [];

    links.forEach(function (link) {
      var id = getHashId(link.getAttribute('href'));
      if (!id) return;
      var target = resolveTarget(id);
      if (!target) return;
      entries.push({ link: link, id: id, target: target });
    });

    return entries;
  }

  function getActiveEntry(entries, direction) {
    if (!entries.length) return null;

    var offset = getOffset();
    var probeY = offset + 1;
    var active = null;
    var bestTop = -Infinity;

    // Prefer the section currently crossing the sticky header probe line.
    entries.forEach(function (entry) {
      var rect = entry.target.getBoundingClientRect();
      if (rect.top <= probeY && rect.bottom > probeY) {
        if (rect.top >= bestTop) {
          active = entry;
          bestTop = rect.top;
        }
      }
    });

    if (active) return active;

    // Still above the first section — nothing should be active.
    var firstTop = entries[0].target.getBoundingClientRect().top;
    if (firstTop > probeY) return null;

    // Past the last section — keep the last item active.
    var last = entries[entries.length - 1];
    if (last.target.getBoundingClientRect().bottom <= probeY) return last;

    // Scroll up: only underline when a section actually hits the probe.
    // Avoid activating the next section early via the fallback below.
    if (direction === 'up') return null;

    // Scroll down: keep the furthest section whose top has passed the probe.
    bestTop = -Infinity;
    entries.forEach(function (entry) {
      var rect = entry.target.getBoundingClientRect();
      if (rect.top <= probeY && rect.top >= bestTop) {
        active = entry;
        bestTop = rect.top;
      }
    });

    return active;
  }

  function destroyNavSpy(root) {
    if (!root) return;

    if (root._ctrNavSpyScroll) {
      window.removeEventListener('scroll', root._ctrNavSpyScroll);
      root._ctrNavSpyScroll = null;
    }
    if (root._ctrNavSpyResize) {
      window.removeEventListener('resize', root._ctrNavSpyResize);
      root._ctrNavSpyResize = null;
    }
    if (root._ctrNavSpyClick) {
      root.removeEventListener('click', root._ctrNavSpyClick);
      root._ctrNavSpyClick = null;
    }
    if (root._ctrNavSpyMqCleanup) {
      root._ctrNavSpyMqCleanup();
      root._ctrNavSpyMqCleanup = null;
    }
    if (root._ctrNavSpyRetry) {
      clearTimeout(root._ctrNavSpyRetry);
      root._ctrNavSpyRetry = null;
    }
  }

  function initNavSpy(scope, root) {
    if (!root) return;

    destroyNavSpy(root);
    root._ctrNavSpyActive = null;

    var mq = window.matchMedia(MOBILE_MQ);
    var entries = [];
    var ticking = false;
    var lastScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var scrollDirection = 'down';

    var isScopeActive = function () {
      if (scope.mobileOnly) return mq.matches;
      // Desktop inline menu is hidden on mobile.
      return !mq.matches;
    };

    var refreshEntries = function () {
      entries = buildEntries(scope, root);
      return entries;
    };

    var update = function () {
      if (!isScopeActive()) return;

      if (!entries.length) refreshEntries();
      if (!entries.length) return;

      var active = getActiveEntry(entries, scrollDirection);
      setActiveLink(scope, root, active ? active.link : null);
    };

    var onScroll = function () {
      var scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      if (scrollY > lastScrollY + 1) {
        scrollDirection = 'down';
      } else if (scrollY < lastScrollY - 1) {
        scrollDirection = 'up';
      }
      lastScrollY = scrollY;

      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        update();
      });
    };

    refreshEntries();
    update();

    if (!entries.length) {
      var tries = 0;
      var retry = function () {
        tries += 1;
        refreshEntries();
        update();
        if (!entries.length && tries < 20) {
          root._ctrNavSpyRetry = setTimeout(retry, 150);
        }
      };
      root._ctrNavSpyRetry = setTimeout(retry, 150);
    }

    root._ctrNavSpyScroll = onScroll;
    root._ctrNavSpyResize = function () {
      refreshEntries();
      update();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', root._ctrNavSpyResize);

    var onMqChange = function () {
      refreshEntries();
      update();
    };

    if (mq.addEventListener) {
      mq.addEventListener('change', onMqChange);
    } else if (mq.addListener) {
      mq.addListener(onMqChange);
    }

    root._ctrNavSpyMqCleanup = function () {
      if (mq.removeEventListener) {
        mq.removeEventListener('change', onMqChange);
      } else if (mq.removeListener) {
        mq.removeListener(onMqChange);
      }
    };

    root._ctrNavSpyClick = function (event) {
      var link = event.target.closest(scope.link);
      if (!link || !root.contains(link)) return;

      var id = getHashId(link.getAttribute('href'));
      if (!id) return;

      var target = resolveTarget(id);
      if (!target) return;

      event.preventDefault();

      var top =
        target.getBoundingClientRect().top +
        (window.pageYOffset || document.documentElement.scrollTop) -
        getOffset();

      var currentY = window.pageYOffset || document.documentElement.scrollTop || 0;
      scrollDirection = top < currentY ? 'up' : 'down';

      window.scrollTo({
        top: Math.max(0, top),
        behavior: 'smooth',
      });

      if (history.replaceState) {
        history.replaceState(null, '', '#' + id);
      }
    };

    root.addEventListener('click', root._ctrNavSpyClick);
  }

  function initAll() {
    SCOPES.forEach(function (scope) {
      document.querySelectorAll(scope.root).forEach(function (root) {
        initNavSpy(scope, root);
      });
    });
  }

  function reinit(event) {
    var section = event && event.target;
    if (!section) {
      initAll();
      return;
    }

    SCOPES.forEach(function (scope) {
      var roots = [];
      if (section.matches && section.matches(scope.root)) {
        roots.push(section);
      }
      if (section.querySelectorAll) {
        section.querySelectorAll(scope.root).forEach(function (el) {
          roots.push(el);
        });
      }
      roots.forEach(function (root) {
        initNavSpy(scope, root);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  window.addEventListener('load', initAll);

  document.addEventListener('shopify:section:load', reinit);
  document.addEventListener('shopify:section:unload', function (event) {
    SCOPES.forEach(function (scope) {
      var root =
        event.target && event.target.querySelector
          ? event.target.querySelector(scope.root)
          : null;
      destroyNavSpy(root);
    });
  });
  document.addEventListener('shopify:section:reorder', initAll);
  document.addEventListener('shopify:section:select', reinit);
  document.addEventListener('shopify:section:deselect', reinit);
})();
